import { render, staticRenderFns } from "./ImgUpload.vue?vue&type=template&id=074f1538&scoped=true&"
import script from "./ImgUpload.vue?vue&type=script&lang=js&"
export * from "./ImgUpload.vue?vue&type=script&lang=js&"
import style0 from "./ImgUpload.vue?vue&type=style&index=0&id=074f1538&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074f1538",
  null
  
)

export default component.exports